export default __webpack_public_path__ + "static/media/IMG_3841 copie.75cf97ae.jpg";